import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import dayjs from 'dayjs';

import { Compensation, EditableCompensation } from 'types';
import { environment } from 'environments';
import { ApiManagementCompensation } from 'components/common';
import { REVERSE_DATE_FORMAT } from 'constants-module';

const MANAGEMENT_CONTROLLER_BASE_URL = `${environment.baseApiUrl}Management`;

export const createManagementCompensation = createAsyncThunk(
  'post:Management/requests',
  async (apiCompensation: ApiManagementCompensation) => {
    const { data } = await axios.post<Compensation>(`${MANAGEMENT_CONTROLLER_BASE_URL}/requests`, apiCompensation);

    return data;
  },
);

export const updateManagementCompensation = createAsyncThunk(
  'post:Management/requests/{requestId}',
  async (apiCompensation: EditableCompensation) => {
    const { data } = await axios.post(
      `${MANAGEMENT_CONTROLLER_BASE_URL}/requests/${apiCompensation.compensationRequestID}`,
      {
        employeeId: apiCompensation.employeeID,
        department: apiCompensation.department,
        status: apiCompensation.status,
        type: apiCompensation.type,
        amount: apiCompensation.amount,
        currency: apiCompensation.currency,
        targetPeriods: apiCompensation.targetPeriods,
        billedOn:
          apiCompensation.billedOn && dayjs(apiCompensation.billedOn).startOf('day').format(REVERSE_DATE_FORMAT),
        employeeComment: apiCompensation.employeeComment,
        reviewerComment: apiCompensation.reviewerComment,
        privacyConsent: apiCompensation.privacyConsent,
      },
    );

    return data;
  },
);
